import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/screening/$screeningId/individuals')({
  component: ScreeningIndividualsLayout,
});

function ScreeningIndividualsLayout() {
  return <Outlet />;
}
